import Home from './Home.js';
import Pepzine from './Pepzine.js';
import Blog from './Blog.js';
import Realisations from './Realisations.js';
import Realisation from './Realisation.js';
import Butchers from './filters/Butchers.js';
import Bakers from './filters/Bakers.js';
import Cheese from './filters/Cheese.js';
import Restaurants from './filters/Restaurants.js';
import Wine from './filters/Wine.js';
import Others from './filters/Others.js';

class Nav {


  /**
   * Constructor
   */
  constructor(){
    // Properties
    this.page = {};
    this.currentPageId = this.getCurrentPageId();
    this.currentPageHandler;

    // general call for home link to realisation
    window.addEventListener(
      'home_realisations_list_item_nav_call',
      this.homeRealisationsListItemNavCall.bind(this),
      false
    );

    // general call for home link to realisations
    window.addEventListener(
      'home_realisations_nav_call',
      this.homeRealisationsNavCall.bind(this),
      false
    );

    // general call for home link to pepzine
    window.addEventListener(
      'home_pepzine_nav_call',
      this.homePepzineNavCall.bind(this),
      false
    );

    // general call for filters event
    window.addEventListener(
      'realisations_filters_nav_call',
      this.realisationsFiltersNavCall.bind(this),
      false
    );

    // general call for single event
    window.addEventListener(
      'realisations_single_nav_call',
      this.realisationsSingleNavCall.bind(this),
      false
    );

    // general call for single to realisations event
    window.addEventListener(
      'realisation_list_call',
      this.realisationListCall.bind(this),
      false
    );

    // general call for single to previous event
    window.addEventListener(
      'realisation_previous_call',
      this.realisationPreviousCall.bind(this),
      false
    );

    // general call for single to next event
    window.addEventListener(
      'realisation_next_call',
      this.realisationNextCall.bind(this),
      false
    );

    // temp: handle back nav
    window.addEventListener('popstate', function(event) {
      console.log("go back");
      // hash is now the previous one
      location.reload();
    }, false);

  }

  /**
   * get current page id
   */
  getCurrentPageId(){
    // Check if Home
    let page = document.getElementById("home-page-container");
    if(!page){
      // Check if Pepzine
      page = document.getElementById("pepzine-page-container");
      if(!page){
        // Check if Realisation
        page = document.getElementById("realisation-page-container");
        if(!page){
          // Check if Realisations
          page = document.getElementById("realisations-page-container");
          if(!page){
            // Check if filter 1
            page = document.getElementById("realisationsFilterButchers-page-container");
            if(!page){
              // Check if filter 2
              page = document.getElementById("realisationsFilterBakers-page-container");
              if(!page){
                // Check if filter 3
                page = document.getElementById("realisationsFilterCheese-page-container");
                if(!page){
                  // Check if filter 4
                  page = document.getElementById("realisationsFilterRestaurants-page-container");
                  if(!page){
                    // Check if filter 5
                    page = document.getElementById("realisationsFilterWine-page-container");
                    if(!page){
                      // Check if filter 6
                      page = document.getElementById("realisationsFilterOthers-page-container");
                      if(!page){
                        // Check if blog
                        page = document.getElementById("blog-page-container");
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    if(!page){
      console.error("Page not found");
    } else {
      return page.id;
    }
  }


  /**
   * Navigation
   */
  navigation(destinationId, postId){

    console.log('LAUNCH NAV TO ' + destinationId);

    // avoid lock event if filter
    if(
      destinationId != "realisationsFilterButchers-page-container"
      && destinationId != "realisationsFilterBakers-page-container"
      && destinationId != "realisationsFilterCheese-page-container"
      && destinationId != "realisationsFilterRestaurants-page-container"
      && destinationId != "realisationsFilterWine-page-container"
      && destinationId != "realisationsFilterOthers-page-container"
    ){
      // throw lock event
      var e = document.createEvent("CustomEvent");
      e.initCustomEvent('lock_screen', false, false, {});
      window.dispatchEvent(e);
    } else {
      console.log('--- throw filter lock event');
      var e = document.createEvent("CustomEvent");
      e.initCustomEvent('lock_filter', false, false, {});
      window.dispatchEvent(e);
    }

    // unset previous page context
    if (this.currentPageId == "home-page-container"){
      this.page.unsetEventsListeners();
    } else if(this.currentPageId == "pepzine-page-container") {
      this.page.unsetEventsListeners();
    } else if(this.currentPageId == "realisations-page-container") {
      this.page.unsetEventsListeners();
    } else if(this.currentPageId == "realisation-page-container") {
      this.page.unsetEventsListeners();
    } else if(this.currentPageId == "realisationsFilterButchers-page-container") {
      this.page.unsetEventsListeners();
    } else if(this.currentPageId == "realisationsFilterBakers-page-container") {
      this.page.unsetEventsListeners();
    } else if(this.currentPageId == "realisationsFilterCheese-page-container") {
      this.page.unsetEventsListeners();
    } else if(this.currentPageId == "realisationsFilterRestaurants-page-container") {
      this.page.unsetEventsListeners();
    } else if(this.currentPageId == "realisationsFilterWine-page-container") {
      this.page.unsetEventsListeners();
    } else if(this.currentPageId == "realisationsFilterOthers-page-container") {
      this.page.unsetEventsListeners();
    } else if(this.currentPageId == "blog-page-container") {
      this.page.unsetEventsListeners();
    } else {
      console.error('current page id not supported:' + this.currentPageId);
      return false;
    }

    // switch page on destination id
    switch (destinationId) {
      case "home-page-container":
        console.log('set new id');
        var prevPageId = this.currentPageId;
        this.currentPageId = destinationId;
        console.log('add loaded listener');
        this.loadedListener = this.pageBuiltEvent.bind(this);
        window.addEventListener('page_built', this.loadedListener, false);
        console.log('home instance');
        this.page = new Home(prevPageId);
        this.page.go();
        break;
      case "blog-page-container":
        console.log('set new id');
        var prevPageId = this.currentPageId;
        this.currentPageId = destinationId;
        console.log('add loaded listener');
        this.loadedListener = this.pageBuiltEvent.bind(this);
        window.addEventListener('page_built', this.loadedListener, false);
        console.log('blog instance');
        this.page = new Blog(prevPageId);
        this.page.go();
        break;
      case "contact-page-container":
        destinationId = "home-page-container";
        console.log('set new id');
        var prevPageId = this.currentPageId;
        this.currentPageId = destinationId;
        console.log('add loaded listener');
        this.loadedListener = this.pageBuiltEvent.bind(this);
        window.addEventListener('page_built', this.loadedListener, false);
        console.log('home instance');
        this.page = new Home(prevPageId, true);
        this.page.go();
        break;
      case "pepzine-page-container":
        console.log('set new id');
        var prevPageId = this.currentPageId;
        this.currentPageId = destinationId;
        console.log('add loaded listener');
        this.loadedListener = this.pageBuiltEvent.bind(this);
        window.addEventListener('page_built', this.loadedListener, false);
        console.log('pepzine instance');
        this.page = new Pepzine(prevPageId);
        this.page.go();
        break;
      case "realisations-page-container":
        console.log('set new id');
        var prevPageId = this.currentPageId;
        this.currentPageId = destinationId;
        console.log('add loaded listener');
        this.loadedListener = this.pageBuiltEvent.bind(this);
        window.addEventListener('page_built', this.loadedListener, false);
        console.log('realisations instance');
        this.page = new Realisations(prevPageId, '/realisations');
        this.page.go();
        break;
      case "realisation-page-container":
        console.log('set new id');
        var prevPageId = this.currentPageId;
        this.currentPageId = destinationId;
        console.log('add loaded listener');
        this.loadedListener = this.pageBuiltEvent.bind(this);
        window.addEventListener('page_built', this.loadedListener, false);
        console.log('realisation instance');
        this.page = new Realisation(prevPageId, postId);
        this.page.go();
        break;
      case "realisationsFilterButchers-page-container":
        console.log('set new id');
        var prevPageId = this.currentPageId;
        this.currentPageId = destinationId;
        console.log('add loaded listener');
        this.loadedListener = this.pageBuiltEvent.bind(this);
        window.addEventListener('page_built', this.loadedListener, false);
        console.log('butchers instance');
        this.page = new Butchers(prevPageId, '/domaines/boucheries-traiteurs');
        this.page.go();
        break;
      case "realisationsFilterBakers-page-container":
        console.log('set new id');
        var prevPageId = this.currentPageId;
        this.currentPageId = destinationId;
        console.log('add loaded listener');
        this.loadedListener = this.pageBuiltEvent.bind(this);
        window.addEventListener('page_built', this.loadedListener, false);
        console.log('bakers instance');
        this.page = new Bakers(prevPageId, '/domaines/boulangeries-patisseries');
        this.page.go();
        break;
      case "realisationsFilterCheese-page-container":
        console.log('set new id');
        var prevPageId = this.currentPageId;
        this.currentPageId = destinationId;
        console.log('add loaded listener');
        this.loadedListener = this.pageBuiltEvent.bind(this);
        window.addEventListener('page_built', this.loadedListener, false);
        console.log('cheese instance');
        this.page = new Cheese(prevPageId, '/domaines/fromageries');
        this.page.go();
        break;
      case "realisationsFilterRestaurants-page-container":
        console.log('set new id');
        var prevPageId = this.currentPageId;
        this.currentPageId = destinationId;
        console.log('add loaded listener');
        this.loadedListener = this.pageBuiltEvent.bind(this);
        window.addEventListener('page_built', this.loadedListener, false);
        console.log('restaurants instance');
        this.page = new Restaurants(prevPageId, '/domaines/restaurants');
        this.page.go();
        break;
      case "realisationsFilterWine-page-container":
        console.log('set new id');
        var prevPageId = this.currentPageId;
        this.currentPageId = destinationId;
        console.log('add loaded listener');
        this.loadedListener = this.pageBuiltEvent.bind(this);
        window.addEventListener('page_built', this.loadedListener, false);
        console.log('wine instance');
        this.page = new Wine(prevPageId, '/domaines/cavistes');
        this.page.go();
        break;
      case "realisationsFilterOthers-page-container":
        console.log('set new id');
        var prevPageId = this.currentPageId;
        this.currentPageId = destinationId;
        console.log('add loaded listener');
        this.loadedListener = this.pageBuiltEvent.bind(this);
        window.addEventListener('page_built', this.loadedListener, false);
        console.log('others instance');
        this.page = new Others(prevPageId, '/domaines/autres');
        this.page.go();
        break;
      default:
        console.log('navigation id is invalid: ' + destinationId);
        return false;
    }
  }


  /**
   * Navigation events
   */
  homeRealisationsListItemNavCall(e){
    console.log('home realisations list item nav call');
    this.navigation(
      'realisation-page-container',
      e.detail.realisation.getAttribute('data-id')
      );
  }
  homeRealisationsNavCall(e){
    console.log('home realisations nav call');
    this.navigation('realisations-page-container');
  }
  homePepzineNavCall(e){
    console.log('home pepzine nav call');
    this.navigation('pepzine-page-container');
  }
  realisationsFiltersNavCall(e){
    console.log('realisations filter nav call');
    switch (e.detail.filter.getAttribute('data-slug')) {
      case "boucheries-traiteurs":
        this.navigation("realisationsFilterButchers-page-container");
        break;
      case "boulangeries-patisseries":
        this.navigation("realisationsFilterBakers-page-container");
        break;
      case "fromageries":
        this.navigation("realisationsFilterCheese-page-container");
        break;
      case "restaurants":
        this.navigation("realisationsFilterRestaurants-page-container");
        break;
      case "cavistes":
        this.navigation("realisationsFilterWine-page-container");
        break;
      case "autres":
        this.navigation("realisationsFilterOthers-page-container");
        break;
      default:
        console.error(
          'filter call is not supported: '
          + e.detail.filter.getAttribute('data-slug')
        );
        return false;
        break;
    }
  }
  realisationsSingleNavCall(e){
    console.log('realisations single nav call');
    this.navigation('realisation-page-container',
      e.detail.realisation.getAttribute('data-id'));
  }
  realisationListCall(e){
    console.log('realisation list call');
    this.navigation('realisations-page-container');
  }
  realisationPreviousCall(e){
    console.log('realisation previous call');
    this.navigation('realisation-page-container',
      e.detail.realisation.getAttribute('data-id'));
  }
  realisationNextCall(e){
    console.log('realisation next call');
    this.navigation('realisation-page-container',
      e.detail.realisation.getAttribute('data-id'));
  }


  /**
   * Built events
   */
  pageBuiltEvent(e) {
    console.log("Page is built");
    window.removeEventListener('page_built', this.loadedListener, false);
    this.pageLoaded(e.detail);
  }


  /**
   * Loaded
   */
  pageLoaded(pageData) {
    console.log('page loaded');
    console.log('add template');
    if(pageData.dry) {
      document.getElementById("realisations-realisations-list").innerHTML = pageData.template;
      this.page.setEventsListeners();
      console.log('navigation complete');
      console.log('--- throw filter unlock event');
      var e = document.createEvent("CustomEvent");
      e.initCustomEvent('unlock_filter', false, false, {});
    } else {
      document.getElementById(this.currentPageId).innerHTML = pageData.template;
      this.page.setEventsListeners();
      console.log('navigation complete');
      console.log('throw unlock event');
      var e = document.createEvent("CustomEvent");
      e.initCustomEvent('unlock_screen', false, false, {});
    }
    console.log('push history');
    history.pushState(null, null, pageData.slug);
    window.dispatchEvent(e);
  }

}

export default Nav;

